import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography, Accordion, AccordionSummary, AccordionDetails, Avatar, } from "@mui/material";
import { TicketReplyRightPanel, UserBox, AvatarWrapper, UserInfoBox, 
    UserNameTypography, UserInfos, UserInfoTl, UserInfoDesc, TicketBox, 
    TicketNo, TicketCard, TicketStatus, TicketDataBox,
     TicketDataTime, } from '../styles/TicketDetails.UI.styled';
import { getFormattedDate, getFormattedDateTime, getTicketStatus, getUserName } from '../../../utils/helpers';
import moment from 'moment';

const getHistoryStatus = (status: string) => {
    if (status === 're_assigned') return 'Re Assigned'
    if (status === 'escalated') return 'Escalated'
    if (status === 'assigned') return 'Assigned'
    return 'Unknown'
}


const TicketDetailsRightPanel = ({ ticketDetails }: any) => {
    const assignmentHistory = ticketDetails?.assignmentHistory || [];

    return (
        <TicketReplyRightPanel className="ticketRightPanel">
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                >
                    <Typography component="span">Customer Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <UserBox>
                        <AvatarWrapper>
                            <Avatar
                                alt={getUserName(ticketDetails?.customer) || "User"}
                                src="/images/static/user-photo2.png"
                                sx={{ width: 36, height: 36 }}
                            />
                        </AvatarWrapper>
                        <UserInfoBox>
                            <UserNameTypography> {getUserName(ticketDetails?.customer)} </UserNameTypography>
                        </UserInfoBox>
                    </UserBox>
                    <UserInfos>
                        <UserInfoTl>Email</UserInfoTl>
                        <UserInfoDesc> {ticketDetails?.customer?.email} </UserInfoDesc>
                    </UserInfos>
                    {ticketDetails?.customer?.phoneNumber && <UserInfos>
                        <UserInfoTl>Contact no</UserInfoTl>
                        <UserInfoDesc> {ticketDetails?.customer?.phoneNumber} </UserInfoDesc>
                    </UserInfos>}
                    <UserInfos>
                        <UserInfoTl>Local time</UserInfoTl>
                        <UserInfoDesc> {getFormattedDateTime(ticketDetails?.createdAt)} </UserInfoDesc>
                    </UserInfos>
                    <UserInfos>
                        <UserInfoTl>Language</UserInfoTl>
                        <UserInfoDesc>English (United States)</UserInfoDesc>
                    </UserInfos>
                </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                >
                    <Typography component="span">Interaction history</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <TicketBox>
                        <TicketNo>Ticket No : {ticketDetails?.ticketId} </TicketNo>
                        <TicketCard> {ticketDetails?.subject} </TicketCard>
                        <TicketStatus>Status: <Typography component="span" sx={{ color: '#D0524D' }}> {getTicketStatus(ticketDetails)} </Typography></TicketStatus>
                    </TicketBox>
                    {[...assignmentHistory].reverse().map((data, idx) => (
                        <TicketDataBox key={idx}>
                            <TicketDataTime>
                                <Typography component="span">{getFormattedDate(data.createdAt)}</Typography>
                                <Typography component="span">{moment(data?.createdAt).format('hh:mma')}</Typography>
                            </TicketDataTime>

                            <UserInfos>
                                <UserInfoTl> Assigner </UserInfoTl>
                                <UserInfoDesc>{getUserName(data.assigner)}</UserInfoDesc>
                            </UserInfos>
                            <UserInfos>
                                <UserInfoTl> Assiged To </UserInfoTl>
                                <UserInfoDesc>{getUserName(data?.assignedAgent)}</UserInfoDesc>
                            </UserInfos>
                            {data.status && <UserInfos>
                                <UserInfoTl> status </UserInfoTl>
                                <UserInfoDesc>{getHistoryStatus(data?.status)}</UserInfoDesc>
                            </UserInfos>}
                            {data.selfNote && <UserInfos>
                                <UserInfoTl> Customer msg </UserInfoTl>
                                <UserInfoDesc>{data.selfNote}</UserInfoDesc>
                            </UserInfos>}
                            {data.movingNote && <UserInfos>
                                <UserInfoTl> Internal team msg </UserInfoTl>
                                <UserInfoDesc>{data.movingNote}</UserInfoDesc>
                            </UserInfos>}
                            {/* <Typography className="ticketContent">{data.content} <Link href="">More</Link></Typography> */}
                        </TicketDataBox>
                    ))}

                </AccordionDetails>
            </Accordion>
        </TicketReplyRightPanel>
    )

}

export default TicketDetailsRightPanel